/**
 * @fileName      mutations
 * @dateTime      2021/4/6 11:32:35
 * @author        Millionfor <millionfor@gmail.com>
 * @description
 */

export default {
  setSelectCsSessionItem (state, payload) {
    state.selectCsSessionItem = payload
  },
  setCsInfo (state, payload) {
    state.csInfo = payload
  },
  setSessionsItrResTime (state, payload) {
    state.sessionsItrResTime = payload
  },
  setMsgCount (state, payload) {
    state.msgCount = payload
  },
  setMsgMtCount (state, payload) {
    state.msgMtCount = payload
  },
  setMsgContent (state, payload) {
    state.msgContent = payload
  },
  setIsFs (state, payload) {
    state.isFs = payload
  }
}



// WEBPACK FOOTER //
// ./src/js/conf/home/store/cs/mutations.js